import React from 'react'
import { NavLink } from 'react-router-dom'

export const NavigationItem = (props) => {
    return (
        
            <main className="font-mono font-bold text-xl text-gray-500 mt-8 lg:mt-0 lg:text-white">
                <NavLink 
                onClick={props.tooltipHandler}
                to={props.link}
                exact
                activeClassName="text-blue-700">
                {props.children}
                </NavLink>
            </main>
    )
}
